export default __webpack_public_path__ + "static/media/Refresh.36f77aea.svg";